<template>
    <el-dialog title="启动环境确认" :visible.sync="visible" width="550px" :close-on-click-modal="false" :close-on-press-escape="false">
        <template v-if="reviewMode == 'script'">
        <p style="margin-top: 20px">检测到你已有一个运行中的<el-button type="text" @click="openOldTraining">实操环境</el-button>。若启动新环境，现有环境将自动关闭，且未保存的进度可能丢失。</p>
        <p style="margin-bottom: 40px">为了避免数据丢失，请确保您已【提交操作结果】并保存所有重要更改。确认无误后，是否仍要继续启动新环境？</p>
        </template>
        <template v-if="reviewMode == 'manual'">
            <p style="margin-top: 20px">检测到你已有一个运行中的实操环境，启动新环境将关闭现有的环境是否启动新环境？</p>
        </template>
        <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="start" v-if="reviewMode == 'script'">仅启动新环境</el-button>
                <el-button type="primary" @click="start" v-if="reviewMode != 'script'">启动新环境</el-button>
                <el-button type="primary" @click="commitAndStart" v-if="reviewMode=='script'">提交结果并启动</el-button>
            </span>
    </el-dialog>
</template>

<script>
export default {
    name: "startConfirmDialog",
    data() {
        return {
            visible: false,
            userInstances: {},
            reviewMode: "script",
            oldQuestionId:null
        }
    },
    methods: {
        open(userInstances, reviewMode) {
            this.visible = true
            this.userInstances = userInstances
            if (this.userInstances.instance_name) {
                var instances = this.userInstances.instance_name.split("_");
                if (instances.length >= 3) {
                    this.oldQuestionId = parseInt(instances[2])
                }
            }
            this.reviewMode = reviewMode
        },
        cancel() {
            this.visible = false
            this.$emit('cancel')
        },
        start() {
            this.visible = false
            this.$emit('start', this.userInstances.id, this.oldQuestionId)
        },
        commitAndStart() {
            this.visible = false
            this.$emit('commitAndStart', this.userInstances.id, this.oldQuestionId)
        },
        openOldTraining() {
            let routeUrl = this.$router.resolve({
                path: "/practicalTraining",
                query: {
                    name: localStorage.getItem("1+XAdministration"),
                    exam: this.$route.query.exam,
                    trainingMirror: this.userInstances.training_id,
                    examPaperId: parseInt(this.$route.query.examPaperId),
                    examPaperQuestionId:  this.oldQuestionId,
                    reviewMode: this.reviewMode
                }
            });
            open(routeUrl.href, '_blank');
        }
    }
}
</script>

<style scoped>
p {
    line-height: 22px;
}
</style>
